import Store from '@/store';

const INACTIVE = 'INACTIVE';

class ProjectCard {
  constructor(project) {
    this.id = project.projectId;
    this.projectId = project.projectId;
    this.name = project.name;
    this.code = project.code;
    this.currency = project.currency;
    this.attachment = project.attachment;
    this.link = project.link;
    this.balance = project.balance;
    this.avgAmount = project.avgAmount;
    this.paymentsPerDay = Math.round(project.paymentsPerDay * 100) / 100;
    this.isInactive = project.status === INACTIVE;
    this.type = project.type;
  }

  goTo(routeName) {
    if (this.isInactive) {
      return;
    }

    this.changeProject(routeName);
  }

  async changeProject(routeName = '') {
    await Store.dispatch('CHANGE_PROJECT', {
      currency: this.currency,
      projectId: this.id,
      routeName,
    });
  }

  async shownQrCode() {
    if (this.isInactive) {
      return;
    }

    await this.changeProject();

    Store.commit('SET_MODAL_PARAMS', {
      type: 'QR',
      params: {
        show: true,
        code: this.code,
        type: 'project',
      },
    });
  }
}

export default ProjectCard;
